import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Root = styled(Typography)(({ theme }) => ({
  fontSize: 28,
  fontWeight: 'bold',
  letterSpacing: '0.29px',
  color: theme.palette.background.default,
}));
